// extracted by mini-css-extract-plugin
module.exports = {"container":"Tables_container__16sqK","tablecontainer":"Tables_tablecontainer__3oS3P","buttonStyle":"Tables_buttonStyle__T2mjy"};